const Join = () => {
  return (
    <section id="discord">
      <div className="container">
          <a data-aos="zoom-in" data-aos-duration="1500" href="https://discord.gg/eqWG6CuyqC" target="_blank" rel="noopener noreferrer"
           className="cta">
            Join Discord
          </a>    
      </div>
    </section>
  );
};

export default Join;
